import React from 'react';
import { Card } from '@repo/ui/Card';

import SmsForwardForm from './SmsForwardForm';
import { Mercury } from '@repo/types/Models';

export interface SmsForwardProps {
  didSwitch: Mercury.Models.Switch;
  canUpdate?: boolean;
  refetch: () => void;
}

const SmsForward = ({ didSwitch, refetch, canUpdate }: SmsForwardProps) => {
  return (
    <Card
      title="SMS forwards"
      description="Messages received by the gateway will be immediately forwarded by the protocol and to the endpoints specified below.
      If no protocol is selected messages will not be forwarded.
      "
    >
      <div className="flex flex-col gap-8 mt-6">
        <SmsForwardForm didSwitch={didSwitch} refetch={refetch} canUpdate={canUpdate} />
      </div>
    </Card>
  );
};

export default SmsForward;
